import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { TopMenuComponent } from './shared/components/top-menu/top-menu.component';
import { FooterComponent } from './shared/components/footer/footer.component';
//import { NoopAnimationsModule } from '@angular/platform-browser/animations';
// 
import {StarratingComponent} from './shared/components/star-rating/starrating.component';

import {MatInputModule} from '@angular/material/input';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RestapiService } from '../app/core/services/restapi.service';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { environment } from '../environments/environment';
import { JwtInterceptorService } from '../app/core/services/jwt-interceptor.service';

// Cookie-law
import { CookieLawModule } from 'angular2-cookie-law';

// ngx
import { NgxSpinnerModule } from "ngx-spinner";

// Shared
import { SharedModule } from '../app/shared/shared.module';

// Directive
// import { PhoneNumberOnlyDirective } from '../app//shared/directives/phone-number-directive';
// import { AlphabetsOnlyDirective } from '../app//shared/directives/alphabets-only-directive';
// import { NumberOnlyDirective } from '../app//shared/directives/numbers-only-directive';
// import { NumberOnlyWithoutCopyPasteDirective } from '../app//shared/directives/numbers-only-directive-without-copy-paste';

/*Sajag */
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
//  Angular material
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MatRadioModule } from '@angular/material/radio';

import { ConfigService } from './core/services/config.service';
import { CreditcheckPopupComponent } from './shared/components/creditcheck-popup/creditcheck-popup.component';

export const configFactory = (configService: ConfigService) => {
  return () => configService.loadConfig();
};
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    TopMenuComponent,
    StarratingComponent,
    CreditcheckPopupComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule, SharedModule, MatSnackBarModule,
    AppRoutingModule, CookieLawModule, NgxSpinnerModule,
    // AlphabetsOnlyDirective, NumberOnlyWithoutCopyPasteDirective, NumberOnlyDirective, PhoneNumberOnlyDirective,
    BrowserAnimationsModule, MatSidenavModule,MatRadioModule,
    FlexLayoutModule, MatInputModule, NgbModule, NgIdleKeepaliveModule.forRoot()

  ],
  providers: [
    { provide: APP_INITIALIZER, useFactory: configFactory, deps: [ConfigService], multi: true },
    RestapiService,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: 'googleTagManagerId', useValue: environment.googleTagManagerId },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptorService, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
